export default __webpack_public_path__ + "static/media/5.c6260e90.jpeg";